/*
 * Self-contained controller for the warranty-terms / care-instructions info
 * popups (sections/custom-popup-section.liquid).
 *
 * Classic, deferred, vanilla JS so it works independently of the large
 * `custom.js` ES module, which does not reliably bind its delegated handlers on
 * the minified live storefront. Keeps these popup buttons working.
 */
(function () {
  "use strict";

  function openModal(selector) {
    var m = document.querySelector(selector);
    if (m) m.classList.add("model-open");
  }
  function closeAll() {
    var list = document.querySelectorAll(".warranty-model, .care-instructions-model");
    for (var i = 0; i < list.length; i++) {
      list[i].classList.remove("model-open");
    }
  }

  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest(".warranty-open")) {
      e.preventDefault();
      openModal(".warranty-model");
      return;
    }
    if (t.closest(".care-instructions")) {
      e.preventDefault();
      openModal(".care-instructions-model");
      return;
    }
    if (
      t.closest(".warranty-model .close-btn-model") ||
      t.closest(".care-instructions-model .close-btn-model") ||
      t.closest(".warranty-model .bg-overlay-modal") ||
      t.closest(".care-instructions-model .bg-overlay-modal")
    ) {
      closeAll();
    }
  });
})();
